import { storeToRefs } from 'pinia'

import createLogger from '@/lib/logger'
import { useAuthStore } from '@/store/auth'

import type { RouteLocationNormalized } from 'vue-router'

const logger = createLogger('userRoleGuard')

/**
 * Handles user role checks for routes
 */
export const userRoleGuard = async (to: RouteLocationNormalized) => {
  logger.log('Running hook...')

  const { isPlarformAdmin } = storeToRefs(useAuthStore())

  try {
    // Platform admins can access all routes
    if (isPlarformAdmin.value) {
      logger.log('Platform admin, allowing access')
      return undefined
    }

    // Check admin access
    const isAdminRoute = to.matched.some((match) => match.meta?.isAdmin)
    if (isAdminRoute && !isPlarformAdmin.value) {
      logger.log('Admin route but not platform admin, redirecting to Metrics')
      return { name: 'NewChat' }
    }

    logger.log('All checks passed, allowing access')
    return undefined
  } catch (error) {
    logger.log('Error checking route access:', error)
    return { name: 'Settings' }
  }
}
